export default "__VITE_ASSET__rdWbwbqX__"